import { normalizeTenantBranding } from "utils/tenantBranding"

const CACHE_PREFIX = "portalTenantResolve:"
const CACHE_TTL_MS = 15 * 60 * 1000

const getCacheKey = host => `${CACHE_PREFIX}${host}`

export const readPortalTenantCache = host => {
  if (typeof window === "undefined" || !host) {
    return null
  }

  try {
    const raw = sessionStorage.getItem(getCacheKey(host))
    if (!raw) {
      return null
    }

    const parsed = JSON.parse(raw)
    if (!parsed?.data || !parsed?.cachedAt) {
      return null
    }

    if (Date.now() - parsed.cachedAt > CACHE_TTL_MS) {
      sessionStorage.removeItem(getCacheKey(host))
      return null
    }

    return {
      ...parsed.data,
      tenantBranding: parsed.data.tenantBranding
        ? normalizeTenantBranding(parsed.data.tenantBranding)
        : null,
    }
  } catch (_err) {
    return null
  }
}

export const writePortalTenantCache = (host, data) => {
  if (typeof window === "undefined" || !host || !data) {
    return
  }

  try {
    sessionStorage.setItem(
      getCacheKey(host),
      JSON.stringify({
        cachedAt: Date.now(),
        data: {
          tenantId: data.tenantId || null,
          name: data.name || "",
          useCustomLogin: Boolean(data.useCustomLogin),
          tenantBranding: data.tenantBranding || null,
        },
      })
    )
  } catch (_err) {
    // Ignore quota / private mode errors.
  }
}

export const clearPortalTenantCache = host => {
  if (typeof window === "undefined" || !host) {
    return
  }

  try {
    sessionStorage.removeItem(getCacheKey(host))
  } catch (_err) {
    // Ignore.
  }
}
